import classNames from 'classnames';
import React from 'react';
import { ICollectionIntegration } from '../../types';
import OptionsContainer from '../Options';
import { INTEGRATION_ASSETS } from '../TextEditor/constants';
import styles from './CollectionSettingsComponents.module.css';

function CollectionDataSource({
  integration,
}: {
    integration: ICollectionIntegration,
  }) {
  return (
    <div className={classNames(styles.block, 'pb-6')}>
      <div className={classNames('is-size-6 has-text-weight-bold with-text-color mb-3')}>
        Data Source
      </div>
      <OptionsContainer
        selected={false}
        className={classNames('is-flex has-fit-content-width is-flex-direction-row is-align-items-center mb-4')}
      >
        <img src={INTEGRATION_ASSETS?.[integration]?.logo} className="mr-3" width={35} alt="Integration Logo" />
        <div className="with-lighter-text-color">{INTEGRATION_ASSETS?.[integration]?.name}</div>
      </OptionsContainer>
    </div>
  );
}
export default CollectionDataSource;
